import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_GENERAL_SETTINGS_UPLOAD_LOGO_ROUTE_NAME = Symbol('admin.settings.upload-logo');
export const TRANSLATION_GROUP_GENERAL_SETTINGS_UPLOAD_LOGO = Symbol('general-settings.upload-logo');

export const SETTINGS_UPLOAD_LOGO_URL = 'admin/project_settings/save';

export const SETTINGS_UPLOAD_LOGO_QUERY_KEY = 'general-settings.upload-logo';

export const ADMIN_GENERAL_SETTINGS_UPLOAD_LOGO_PERMISSIONS = {
  PROJECTSETTINGS_EDIT: new Permission(
    PermissionsList.admin.PROJECTSETTINGS_EDIT,
  ),
};
